export const elementsGap = '10px';
export function elementSize(elementPerRow: number): string {
  return `0 1 calc(${100 / elementPerRow}% - ${this.elementsGap})`;
}

export function arrayOne(n: number): any[] {
  return Array(n);
}
